import EfSpec from '@elem/ui/ef-spec';
import { useEffect, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { isH5, isPad, isPC, isDesktop } = useMediaDevice();
    const { t } = useLang('Oasis.BackupPriority');

    const [loaderVideo1, setLoaderVideo1] = useState(false);
    const [loaderVideo2, setLoaderVideo2] = useState(false);

    useEffect(() => {
        if (isH5) return;
        const container = document.querySelector('#BackupPriority') as HTMLDivElement;
        const s = container.offsetHeight / (window.innerHeight + container.offsetHeight);
        const scene1 = AniContainer.create({
            triggerElement: container, // 触发元素
            triggerHook: 1, // 触发时机 1 进入 0 离开
            offset: 0,
            duration: window.innerHeight + container.offsetHeight,
            asyncFromTo: [[container, { opacity: 1 }, { opacity: 0 }, 0.1]],
            asyncTimeLine: [s],
        });
        return () => {
            scene1.destroy();
        };
    }, [isPad, isH5, isPC, isDesktop]);

    // 懒加载视频
    useEffect(() => {
        const loader1 = AniContainer.create({
            triggerElement: '#SmartBackup1',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setLoaderVideo1(true);
            },
        });
        const loader2 = AniContainer.create({
            triggerElement: '#SmartBackup1',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setLoaderVideo2(true);
            },
        });

        return () => {
            loader1.destroy();
            loader2.destroy();
        };
    }, []);

    // 视频播放
    const [start1, setStart1] = useState(false);
    const [start2, setStart2] = useState(false);
    useEffect(() => {
        const box1 = document.querySelector('#BackupPriority .box.box1') as HTMLDivElement;
        const box2 = document.querySelector('#BackupPriority .box.box2') as HTMLDivElement;
        // 是否完全可见
        const show = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        if (entry.target === box1) {
                            setStart1(true);
                        }
                        if (entry.target === box2) {
                            setStart2(true);
                        }
                    }
                });
            },
            {
                threshold: 0.6,
            },
        );
        show.observe(box1);
        show.observe(box2);
        () => {
            show.disconnect();
        };
    }, []);

    return (
        <div className={`${styles.TheComp}`} id="BackupPriority">
            <EfSpec />
            <div className="container">
                <div className="box box1">
                    <div className="title">{t('card1.title')}</div>
                    <div className="desc">
                        {t.rich('card1.desc', {
                            h: (v: string) => <span className="highlight">{v}</span>,
                        })}
                    </div>
                    {loaderVideo1 && (isPC || isDesktop || isPad) ? (
                        <EfVideo
                            pc="https://websiteoss.ecoflow.com/upload/video/1735787139051/backup_priority.mp4"
                            poster="https://websiteoss.ecoflow.com/upload/image/1735787270229/backup_priority.jpg"
                            startPlay={start1}
                            key="video1-pc"
                            loop
                            preload="none"
                        />
                    ) : (
                        <EfVideo
                            pc="https://websiteoss.ecoflow.com/upload/video/1735787353496/backup_proority_M.mp4"
                            poster="https://websiteoss.ecoflow.com/upload/image/1735787431397/backup_proority_M.jpg"
                            startPlay={start1}
                            key="video1-h5"
                            loop
                            preload="none"
                        />
                    )}
                </div>
                <div className="box box2">
                    <div className="title">{t('card2.title')}</div>
                    <div className="desc">
                        {t.rich('card2.desc', {
                            h: (v: string) => <span className="highlight">{v}</span>,
                        })}
                    </div>
                    {loaderVideo2 && (isPC || isDesktop || isPad) ? (
                        <EfVideo
                            pc="https://websiteoss.ecoflow.com/upload/video/1735870727821/stay_powered.mp4"
                            poster="https://websiteoss.ecoflow.com/upload/image/1735639018740/BackupPriority2-poster-h5.png"
                            startPlay={start2}
                            key="video2-pc"
                            loop
                            preload="none"
                        />
                    ) : (
                        <EfVideo
                            pc="https://websiteoss.ecoflow.com/upload/video/1735637190381/BackupPriority2-h5.mp4"
                            poster="https://websiteoss.ecoflow.com/upload/image/1735639018924/BackupPriority2-poster.jpeg"
                            startPlay={start2}
                            key="video2-h5"
                            loop
                            preload="none"
                        />
                    )}
                </div>
            </div>
            <EfSpec />
        </div>
    );
}
